import { progressStateComponentSiteCoreKeys } from "../../manageBulkProcess/siteCore/SiteCoreKeys";

export const BulkProcessFormKey = {
  bulkProcessName: "bulkProcessName",
  file: "file",
} as const;

export const BulkCreateProgramDownloadFormKey = {
  clientId: "clientId",
} as const;

export interface BulkCreateProgramClientList {
  id: string;
  name: string;
  clientCode: string;
}

export interface BulkUploadStatusPayload {
  bulkImportId: string;
  category?: string;
}
export interface BulkUploadStatusResponse {
  totalRecords: number;
  processedRecords: number;
  unProcessRecords: number;
  status: string;
  bulkImportId: string;
  processName: string;
  documentId?: string; // optional, if the file is uploaded
  processedParticipants?: number;
  totalParticipants?: number;
  unProcessedParticipants?: number;
}
export const bulkImportBaseFileName = "Bulk_Create_Program_";

export const processedPrograms = "_Processed Programs";
export const unprocessedPrograms = "_Unprocessed Programs";

export const bulkDocumentType = "bulk_program_upload";

export type DownloadType = "processedReport" | "unprocessedReport";
export const DownloadParamType = {
  PROCESSED_REPORT: "processedReport",
  UNPROCESSED_REPORT: "unprocessedReport",
};

export type ProgramFlowMode =
  (typeof PROGRAM_FLOW_MODES)[keyof typeof PROGRAM_FLOW_MODES];

export const PROGRAM_FLOW_MODES = {
  VIEW: "VIEW",
  EDIT: "EDIT",
  CREATE: "CREATE",
} as const;
